export default __webpack_public_path__ + "static/media/tiktok_icon.fa5f22dc.webp";